import { initialRoleData, RoleData } from "./Role";
export interface UserData {
  id: number;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  roleId: number;
  isActive: boolean;
  isConfirmed: boolean;
  primaryPhone: string;
  genderId: number;
  dateOfBirth: Date;
  nationalIdNumber: string | null;
  secondaryPhone: string | null;
  roles: RoleData;
  profileImageBase64: string | null;
  profileImageMime: string | null;
  profileImagePath: string | null;
}

export const initialUserData: UserData = {
  id: 0,
  firstName: "",
  middleName: "",
  lastName: "",
  email: "",
  roleId: 0,
  isActive: false,
  isConfirmed: false,
  primaryPhone: "",
  genderId: 0,
  dateOfBirth: new Date(),
  nationalIdNumber: null,
  secondaryPhone: null,
  roles: initialRoleData,
  profileImageBase64: null,
  profileImageMime: null,
  profileImagePath: null,
};
